export default {"src":"/_next/static/media/logo_regular_green.c9cb16c3.svg","height":24,"width":126,"blurWidth":0,"blurHeight":0};